import { FC, memo } from 'react'

import { Box } from '@chakra-ui/react'

type Props = {
  html?: string
}

const RenderRawHTML: FC<Props> = ({ html }) => {
  if (!html) return null
  return (
    <Box id="teste" className="accessible" sx={{ 'ol, ul': { ps: 4 } }} dangerouslySetInnerHTML={{ __html: html }} />
  )
}

export default memo(RenderRawHTML)
